export const m2l2Solution = `// Destructure the \`cat\` tuple to call print on each member.

use debug::PrintTrait;

fn main() {
    let cat = ('Furry McFurson', 3);
    // do not modify code on this line or above

    //TODO: Fix me to make the code compile
	let (name, age) = cat;

    // do not modify code on this line or below
 
    name.print();
    age.print();
}

#[test]
fn test_compile() {
    assert(1 == 1, 'Surprising');
    main();
}`;
